module.exports = __webpack_public_path__ + "img/main-1.b6ec5ec0.jpg";